export type LocationPickerListener = () => void;

const listeners = new Set<LocationPickerListener>();

export const addLocationPickerListener = (
  listener: LocationPickerListener,
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitLocationPickerEvent = () => {
  listeners.forEach((listener) => {
    listener();
  });
};
